import { createContext } from 'react'

type Toggle = () => void

export const DemoModeToggleContext = createContext<Toggle | undefined>(undefined)
export const DemoModeValueContext = createContext<boolean | undefined>(undefined)
